import { TemplateRef } from '@angular/core';

export interface ITabOption<TValue = any, TTemplate = any> {
  label: string;
  value?: TValue;
  key?: string;
  readonly template: TemplateRef<TTemplate> | null;
  setTemplate?(template: TemplateRef<TTemplate> | null): void;
}

export class TabOptionImpl<TValue = any, TTemplate = any> implements ITabOption<TValue, TTemplate> {
  constructor(
    public readonly label: string,
    public readonly value?: TValue,
    public template: TemplateRef<TTemplate> | null = null,
    public readonly key?: string
  ) {
    this.template ||= null;
  }

  public setTemplate(template: TemplateRef<TTemplate> | null): void {
    this.template = template || null;
  }
}

interface TabOptionCtor {
  new <TValue = any, TTemplate = any>(
    label: string,
    value?: TValue,
    template?: TemplateRef<TTemplate>,
    key?: string
  ): TabOption<TValue, TTemplate>;
}

export type TabOption<TValue = any, TTemplate = any> = TabOptionImpl<TValue, TTemplate> | ITabOption<TValue, TTemplate>;
export const TabOption: TabOptionCtor = TabOptionImpl;
